import { useQuery } from "@tanstack/react-query";
import { IDropdownOption } from "components/atoms";
import { ExamApi, examsApi } from "api/examsApi";
import { QUERIES_KEYS } from "queries";

export interface ExamOption extends IDropdownOption {
  exam?: ExamApi;
}
export const useExamOptions = () => {
  const { isLoading, data } = useQuery({
    queryKey: [QUERIES_KEYS.EXAMS(0, 1_000_000, "", "")],
    queryFn: () => examsApi.fetch(0, 1_000_000),
  });

  const options = (data?.data.data ?? []).map((x) => ({
    value: x.id.toString(),
    label: x.name,
    exam: x,
  }));

  return { loading: isLoading, options };
};
